import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { Typography } from 'fronton-react';
import { Container, InstoreCategoryCard } from 'common/components';
import { checkScreenType, getInstoreCategoryData } from 'utils';
import { selectCategories } from '../../../selectors';
import { carouselHeaderStyles, itemStyles, OtherCategoriesSection } from './styles';
import { selectPageModelStoreName } from 'store/pageModel';
import { Carousel } from 'common/components/carousel-components/carousel';
import { CarouselItem } from 'common/components/carousel-components/carousel-item';
import { patchUrlByLocale } from 'utils/patch-url-by-locale';
import { selectWindowType, WindowTypes } from 'store/pageStore';
import { OtherMobile } from './other-mobile';

export const OtherCategories = memo(() => {
	const categories = useSelector(selectCategories);
	const storeName = useSelector(selectPageModelStoreName);
	const currentWindowType = useSelector(selectWindowType);
	const isMobile = checkScreenType(currentWindowType, WindowTypes.mobile);

	if (!categories) {
		return null;
	}

	return (
		<OtherCategoriesSection data-qa="other-categories-container">
			<Container>
				<Typography variant={'h3'} as="h3" className={carouselHeaderStyles}>
					Другие услуги
				</Typography>
				{isMobile ? (
					<OtherMobile categories={categories} storeName={storeName} />
				) : (
					<Carousel
						fullScroll
						controlSettings={{
							variant: 'secondary',
							size: 'l',
							rounded: true,
							iconOnly: true,
							iconSize: 16,
						}}
					>
						{categories.map(category => {
							const cardData = getInstoreCategoryData(category, storeName);
							return (
								<CarouselItem
									key={`category-${category.name}`}
									href={patchUrlByLocale(category.categoryUrl)}
									variant="secondary"
									className={itemStyles}
								>
									<InstoreCategoryCard type="other" {...cardData} />
								</CarouselItem>
							);
						})}
					</Carousel>
				)}
			</Container>
		</OtherCategoriesSection>
	);
});
